import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
} from "firebase/remote-config"

import { firebaseApp } from "@firebaseConfig/clientApp"

const REMOTE_CONFIG_KEY = "event_assets_updated"

export const fetchEventConfig = (): Promise<void> => {
  return new Promise((resolve, reject) => {
    const remoteConfig = getRemoteConfig(firebaseApp)

    fetchAndActivate(remoteConfig)
      .then(() => {
        const remoteFlagData = getValue(
          remoteConfig,
          REMOTE_CONFIG_KEY,
        ).asString()

        if (!remoteFlagData) return false
        const remoteData = JSON.parse(remoteFlagData)
        if (remoteData) {
          resolve(remoteData)
        } else {
          resolve()
        }
      })
      .catch((error) => {
        console.error("Error fetching remote config:", error)
        reject(error)
      })
  })
}
